import React, { useEffect } from 'react';
import { TaskSection } from 'components/common/TaskSection';
import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import { useProcurementOrderOperations } from '@hooks';
import { ebikesServices, vehiclesServices } from '@services';
import { showError } from '@utils';
import { FieldV2 } from 'components/common/form-controls';

import styles from './procurementOrderContent.style';

const VehicleDetails = ({ index }) => {
  const { vehicles = [] } = useProcurementOrderOperations(false);
  const methods = useFormContext();
  const selectedSku = methods.watch(`skuGroups.${index}.vehicleDetails.skuId`);
  const isLocal = methods.watch(`skuGroups.${index}.isLocal`);

  const vehiclesOptions = vehicles?.map((vehicle) => ({
    value: vehicle.id,
    text: `(${vehicle.id}) ${vehicle.title} - ${vehicle.fee}`,
  }));

  const onSkuChange = async (value) => {
    if (!value || !value.value) return;

    const vehicle = vehicles.find((v) => v.id === value.value);
    let response = {};

    if (vehicle) {
      try {
        if (value.value.includes('ICB')) {
          response = await ebikesServices.getEbike(value.value);
        } else {
          response = await vehiclesServices.getVehicle(value.value);
        }
      } catch (error) {
        showError(error);
      }
      methods.setValue(`skuGroups.${index}.vehicleDetails.skuId`, value.value);
      methods.setValue(
        `skuGroups.${index}.vehicleDetails.manufacturer`,
        response?.data?.properties?.brand
      );
      methods.setValue(
        `skuGroups.${index}.vehicleDetails.model`,
        response?.data?.properties?.model
      );
      methods.setValue(
        `skuGroups.${index}.vehicleDetails.edition`,
        response?.data?.properties?.edition
      );
      methods.setValue(
        `skuGroups.${index}.vehicleDetails.engineDisplacement`,
        response?.data?.properties?.engine?.displacement
      );
      methods.setValue(
        `skuGroups.${index}.vehicleDetails.enginePower`,
        response?.data?.properties?.engine?.powerHp
      );
      methods.setValue(
        `skuGroups.${index}.vehicleDetails.fuelType`,
        response?.data?.properties?.engine?.fuelType
      );
      methods.setValue(
        `skuGroups.${index}.vehicleDetails.emissions`,
        response?.data?.properties?.engine?.emissions
      );
      methods.setValue(
        `skuGroups.${index}.vehicleDetails.transmission`,
        response?.data?.properties?.transmission
      );
      methods.setValue(
        `skuGroups.${index}.vehicleDetails.year`,
        response?.data?.properties?.year
      );
      methods.setValue(
        `skuGroups.${index}.equipmentDetails.spareTyre`,
        response?.data?.spareTyre
      );
      methods.setValue(
        `skuGroups.${index}.equipmentDetails.repairKit`,
        response?.data?.repairKit
      );
      methods.setValue(
        `skuGroups.${index}.equipmentDetails.doorMats`,
        response?.data?.doorMats
      );
      methods.setValue(
        `skuGroups.${index}.equipmentDetails.homeCharger`,
        response?.data?.homeCharger
      );
      methods.setValue(
        `skuGroups.${index}.equipmentDetails.fastCharger`,
        response?.data?.fastCharger
      );
      methods.setValue(`skuGroups.${index}.name`, response?.data?.name);
      methods.setValue(
        `skuGroups.${index}.totalVehicles`,
        response?.data?.totalVehicles || 0
      );
      methods.setValue(
        `skuGroups.${index}.totalPrice.number`,
        response?.data?.totalPrice?.number || 0
      );
      methods.setValue(`skuGroups.${index}.isLocal`, true);
    }
  };

  useEffect(() => {
    if (selectedSku) {
      onSkuChange(selectedSku);
    }
  }, [selectedSku, index]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TaskSection title="Vehicle Details" isEmbedded>
      <Box sx={styles.row}>
        <FieldV2
          label="SKU"
          name={`skuGroups.${index}.vehicleDetails.skuId`}
          control={methods.control}
          type="autocomplete"
          options={vehiclesOptions}
          isRequired
          disabled={!isLocal}
        />
        <FieldV2
          label="Manufacturer"
          name={`skuGroups.${index}.vehicleDetails.manufacturer`}
          control={methods.control}
          type="text"
          disabled
        />
        <FieldV2
          label="Model"
          name={`skuGroups.${index}.vehicleDetails.model`}
          control={methods.control}
          type="text"
          disabled
        />
        <FieldV2
          label="Edition"
          name={`skuGroups.${index}.vehicleDetails.edition`}
          control={methods.control}
          type="text"
          disabled
        />
      </Box>
      <Box sx={styles.row}>
        <FieldV2
          label="Engine Displacement"
          name={`skuGroups.${index}.vehicleDetails.engineDisplacement`}
          control={methods.control}
          type="text"
          disabled
        />
        <FieldV2
          label="Engine Power"
          name={`skuGroups.${index}.vehicleDetails.enginePower`}
          control={methods.control}
          type="text"
          disabled
        />
        <FieldV2
          label="Fuel Type"
          name={`skuGroups.${index}.vehicleDetails.fuelType`}
          control={methods.control}
          type="text"
          disabled
        />
      </Box>
      <Box sx={styles.row}>
        <FieldV2
          label="Emissions"
          name={`skuGroups.${index}.vehicleDetails.emissions`}
          control={methods.control}
          type="text"
          disabled
        />
        <FieldV2
          label="Transmission"
          name={`skuGroups.${index}.vehicleDetails.transmission`}
          control={methods.control}
          type="text"
          disabled
        />
        <FieldV2
          label="Year"
          name={`skuGroups.${index}.vehicleDetails.year`}
          control={methods.control}
          type="text"
          disabled
        />
      </Box>
    </TaskSection>
  );
};

export default VehicleDetails;
